const AboutMeCode = () => {
  return (
    <div>
      <div className="overflow-hidden rounded-lg border border-gray-700 shadow-lg bg-[#011627] ">
        <div className="flex items-center bg-black">
          <div className="flex ml-3">
            <div className="mr-2 w-4 h-4 bg-red-500 rounded-full" />
            <div className="mr-2 w-4 h-4 bg-yellow-500 rounded-full" />
            <div className="w-4 h-4 bg-green-500 rounded-full" />
          </div>
          <p className="p-4 w-full text-lg font-semibold text-center uppercase mr-[4.5rem]">
            About Me
          </p>
        </div>

        <div className="overflow-auto p-4 text-sm leading-relaxed max-h-300 code">
          <span className="text-purple-400">function</span>{" "}
          <span className="text-blue-500">createBeautifulWebsite </span>
          () &#123;
          <br /> <span className="text-purple-400">const</span>{" "}
          <span className="text-yellow-400">html</span> ={" "}
          <span className="text-green-300">'📄 HTML'</span>;
          <br /> <span className="text-purple-400">const</span>{" "}
          <span className="text-yellow-400">css</span> ={" "}
          <span className="text-green-300">'🎨 CSS'</span>;
          <br /> <span className="text-purple-400">const</span>{" "}
          <span className="text-yellow-400">js</span> ={" "}
          <span className="text-green-300">'💡 JavaScript'</span>;
          <br />
          <br /> <span className="text-blue-500">console.log(`</span>{" "}
          <span className="text-yellow-400">$ &#123; html &#125;</span> +{" "}
          <span className="text-yellow-400">$ &#123; css &#125;</span> +{" "}
          <span className="text-yellow-400">$ &#123; js &#125;</span>
          <span className="text-red-400">= stunning websites! 🌟`</span>
          );
          <br />
          &#125;
          <br />
          <span className="text-blue-500"> createBeautifulWebsite </span>
          ();
        </div>
      </div>
    </div>
  );
};

export default AboutMeCode;
